import { PdlLoanDetail } from '@/features';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/pdl/loans/$loanId')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PdlLoanDetail />;
}
